import React from 'react';
import { AI_NO_KEY_MSG } from '../hooks/useAiAction';

export function AiSparkButton({ onClick, loading, disabled, label = 'KI', title, small }) {
  const off = disabled || loading;
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={off}
      title={title || label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        height: small ? 22 : 28,
        padding: small ? '0 8px' : '0 10px',
        borderRadius: 6,
        background: loading ? '#e2ebe3' : 'linear-gradient(135deg, rgba(117,118,201,0.12), rgba(29,190,116,0.14))',
        border: '1px solid rgba(117,118,201,0.35)',
        color: loading ? '#93a89a' : '#4f4b9e',
        fontSize: small ? 11 : 12,
        fontWeight: 600,
        cursor: off ? 'not-allowed' : 'pointer',
        opacity: disabled && !loading ? 0.55 : 1,
        flexShrink: 0,
      }}
    >
      {loading ? (
        <span style={{ width: 10, height: 10, border: '2px solid #7576c9', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.7s linear infinite' }} />
      ) : (
        <span>✨</span>
      )}
      {label}
    </button>
  );
}

export function AiErrorBanner({ message, onDismiss }) {
  if (!message) return null;
  const isKey = message.includes('API-Key') || message.includes('konfiguriert');
  return (
    <div
      role="alert"
      style={{
        fontSize: 11,
        color: isKey ? '#b45309' : '#dc2626',
        marginTop: 6,
        padding: '6px 10px',
        borderRadius: 6,
        background: isKey ? 'rgba(245,158,11,0.08)' : 'rgba(220,38,38,0.07)',
        border: `1px solid ${isKey ? 'rgba(245,158,11,0.28)' : 'rgba(220,38,38,0.2)'}`,
        lineHeight: 1.45,
        display: 'flex',
        gap: 8,
        alignItems: 'flex-start',
        justifyContent: 'space-between',
      }}
    >
      <span>{message}</span>
      {onDismiss && (
        <button type="button" onClick={onDismiss} style={{ border: 'none', background: 'none', cursor: 'pointer', color: 'inherit', padding: 0, fontSize: 14 }}>×</button>
      )}
    </div>
  );
}

export function AiThinkingBar({ label = 'KI arbeitet…' }) {
  return (
    <div
      role="status"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 10px',
        borderRadius: 8,
        background: 'linear-gradient(90deg, rgba(117,118,201,0.08), rgba(29,190,116,0.1), rgba(117,118,201,0.08))',
        backgroundSize: '200% 100%',
        animation: 'crmOutcomeThinkBg 1.4s ease-in-out infinite',
        border: '1px solid rgba(117,118,201,0.22)',
        marginTop: 8,
        fontSize: 11,
        fontWeight: 600,
        color: '#4f4b9e',
      }}
    >
      <style>{`@keyframes crmOutcomeThinkBg { 0%,100%{background-position:0% 50%} 50%{background-position:100% 50%} }`}</style>
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#7576c9', animation: 'spin 0.8s linear infinite' }} />
      {label}
    </div>
  );
}

export function AiNoKeyHint({ compact }) {
  return (
    <div style={{
      fontSize: compact ? 10 : 11,
      color: '#92400e',
      padding: compact ? '6px 8px' : '8px 10px',
      borderRadius: 8,
      background: 'rgba(245,158,11,0.08)',
      border: '1px solid rgba(245,158,11,0.25)',
      lineHeight: 1.45,
    }}>
      {AI_NO_KEY_MSG}
      <div style={{ marginTop: 4, fontSize: 10, color: '#78716c' }}>
        Tipp: <strong>Google Gemini</strong> in den Einstellungen – Free Tier oft ohne Kreditkarte (aistudio.google.com).
      </div>
    </div>
  );
}
